import S3 from 'aws-s3';
import Compressor from 'compressorjs';

const AWS_ACCESS_KEY_ID=process.env.REACT_APP_TC_AWS_ACCESS_KEY_ID
const AWS_SECRET_ACCESS_KEY=process.env.REACT_APP_TC_AWS_SECRET_ACCESS_KEY

const awsData = JSON.parse(JSON.stringify({ 
  bucketName: 'top-court',
  region: "ap-southeast-1", 
  accessKeyId: AWS_ACCESS_KEY_ID,
  secretAccessKey: AWS_SECRET_ACCESS_KEY,
  secretKeyId: AWS_SECRET_ACCESS_KEY // same as secretAccessKey
}));


export async function handleUpload(selectedFile,
  compress = 0.5 // set to 0 to no need to compress
) {
    if (!selectedFile) return []

    let newFileName = `${new Date().getTime()}`
    awsData.dirName = `topcourt-staging`

    let uploadFile = selectedFile

    if (compress) {
      uploadFile = await new Promise((resolve, reject) => {
        new Compressor(selectedFile, {
          quality: compress,
          success: resolve,
          error: reject
        })
      })
    }

    const newFile = new File([uploadFile], newFileName, {
      type: "image/png",
      lastModified: new Date()
    })

    const S3Client = new S3(awsData)
    const imageFile = await S3Client.uploadFile(newFile, newFileName)

    return [imageFile.location]
}